var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBin = function SvgBin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 14 17"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.333 1.667H0V2.5h13.333z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m10.786 2.5-.739 13.333-6.76.003L2.546 2.5zm-9.12-.833.788 14.215c.027.44.39.785.832.785h6.763a.834.834 0 0 0 .832-.785l.787-14.215zM2.5 0h8.333c.46 0 .834.374.834.833h-10C1.667.373 2.04 0 2.5 0"
  })));
};
export default SvgBin;